<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import LayerFeaturesList from '@/components/layers/variants/LayerFeaturesList.vue'

const props = defineProps({
  layer: {
    type: Object,
    required: true
  }
})

const route = useRoute()
const store = useStore()
const orgId = computed(() => route.params.org_id)

const layerCode = computed(() => {
  return props.layer?.uuid
})
</script>

<template>
  <div>
    <!-- Features List -->
    <LayerFeaturesList :code="layerCode" />
  </div>
</template>